export default function formEnterToTab(e) {
  if (!e) return;
  if (e.key !== "Enter") return;
  if (e.shiftKey) return;

  const target = e.target;
  if (target.tagName === "TEXTAREA") return;
  if (target.tagName === "BUTTON") return;
  if (target.tagName === "A") return;

  e.preventDefault();

  const form = e.currentTarget;

  const selector = [
    'input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"])',
    "select",
    "textarea",
    '[tabindex]:not([tabindex="-1"])',
    'button[type="submit"]',
  ].join(", ");

  const allNodes = Array.from(form.querySelectorAll(selector));

  const focusableNodes = allNodes.filter(el => {
    if (el.offsetParent === null) return false;
    if (el.disabled || el.readOnly) return false;
    if (el.classList.contains("MuiAutocomplete-popupIndicator")) return false;
    if (el.classList.contains("MuiAutocomplete-clearIndicator")) return false;

    return true;
  });

  const index = focusableNodes.indexOf(target);
  if (index === -1) return;
  const nextIndex = index + 1;

  if (nextIndex < focusableNodes.length) {
    focusableNodes[nextIndex].focus();

    if (typeof focusableNodes[nextIndex].select === "function") {
      focusableNodes[nextIndex].select();
    }
  }
}
